import logger from "../../../utils/logger";
import { loadLocations } from "../reducer/locations";
import {
  pageLoaded,
  sendFeedback,
  setError,
  setLoading,
  setToast,
  loadVolunteers,
  loadVolunteersSuccess
} from "../reducer/ui";

const pageLoadedFlow = () => ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === pageLoaded.type) {
    dispatch(loadLocations());
  }
};

const sendFeedbackFlow = ({ postFeedback }) => ({ dispatch, getState }) => (
  next
) => async (action) => {
  next(action);
  if (action.type === sendFeedback.type) {
    dispatch(setLoading(true));
    try {
      const response = await postFeedback(action.payload);
      logger()(response.data);
      dispatch(setToast(response.data.msg));
    } catch (error) {
      if (error.response && error.response.data && error.response.data.msg) {
        dispatch(setError(error.response.data.msg));
      } else dispatch(setError(error.message));
    }
    dispatch(setLoading(false));
  }
};



const volunteerImageUrl = (name) =>
  "https://res.cloudinary.com/dio1saxjw/image/upload/" +
  "w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_white,b_rgb:17a2b8" +
  "/volunteers/" +
  name;

  const loadVolunteersFlow = ({ getVolunteerList }) => ({ dispatch, getState }) => (
    next
  ) => async (action) => {
    next(action);
    if (action.type === loadVolunteers.type) {
      dispatch(setLoading(true));
      try {
        const response = await getVolunteerList();
        logger()(response.data);
        const list = operate(transform(response.data.feed.entry));
        dispatch(loadVolunteersSuccess(list));
      } catch (error) {
        dispatch(setError(error.message));
      }
      dispatch(setLoading(false));
    }
  };

const transform = (list) =>
  list.map((item, _id) => ({
    _id: _id.toString(),
    name: item["gsx$name"] ? item["gsx$name"]["$t"] : "",
    role: item["gsx$role"] ? item["gsx$role"]["$t"] : "",
    facebook: item["gsx$facebook"] ? item["gsx$facebook"]["$t"] : "",
    github: item["gsx$github"] ? item["gsx$github"]["$t"] : "",
    linkedin: item["gsx$linkedin"] ? item["gsx$linkedin"]["$t"] : "",
    image: item["gsx$image"] ? item["gsx$image"]["$t"] : "",
    portfolio: item["gsx$portfolio"] ? item["gsx$portfolio"]["$t"] : "",
  }));

const operate = (list) =>
  list.map((volunteer, _id) => {
    const ar = volunteer.image.split("/");
    const name = ar[ar.length - 1];
    return {
      ...volunteer,
      image: volunteerImageUrl(name),
    };
  });

const uiFlows = [pageLoadedFlow, sendFeedbackFlow,loadVolunteersFlow];
export default uiFlows;
